import * as React from "react";

class Template {
  static selectLanguage = (ja, en) => {
    return process.env.GATSBY_LANG === "ja" ? ja : en;
  };

  static insertSpanTag = (target) => {
    let texts = [];
    if (typeof target === "string") {
      const targets = target.split("");
      for (let i = 0; i < targets.length; i++) {
        texts.push(<span key={i}>{targets[i]}</span>);
      }
    }
    return texts;
  };
}

export default Template;
